@use "@fukuri-admins/ui/layout" as *;

.content {
  display: flex;
  flex-direction: column;
  gap: spacing('16');
  height: inherit;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.title {
  @include typography('Jp/20_W6');
  color: text('High');
}

.bannerItem {
  display: flex;
  gap: spacing('8');
  border: 1px solid border('Tertiary');
  border-radius: borderRadius('lg');
  padding: spacing('24') spacing('16') spacing('24') spacing('4');
  overflow: visible;
}

.bannerItemIcon {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: spacing('8');
  color: text('Low');
  cursor: grab;

  // svgIcon クラスが color: text('High') を持つため、詳細度を上げて上書きする
  svg {
    color: inherit;
  }
}

.bannerItemContent {
  flex: 1;
  min-width: 0;
  display: flex;
}

.bannerItemSortOrder {
  display: flex;
  align-items: center;
  width: 40px;
  padding: spacing('8');
  @include typography('Jp/16_W6');
  color: text('High');
}

.bannerItemStatus {
  display: flex;
  align-items: center;
  padding: spacing('12');
}

.bannerItemImage {
  flex-shrink: 1;
  align-self: center;
  width: 374px;
  min-width: 187px;
  padding: 0 spacing('12');
  aspect-ratio: 374 / 120;

  &[data-active="false"] {
    opacity: 0.5;
  }

  img {
    width: 100%;
    height: 100%;
    border-radius: borderRadius('lg');
    object-fit: cover;
  }
}

.bannerItemInfo {
  flex: 1;
  min-width: 200px;
  height: 120px;
  display: flex;
  flex-direction: column;
  gap: spacing('8');
  padding: 0 spacing('12');

  .bannerItemInfoTitle {
    @include typography('Jp/16_W6');
    color: text('High');
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .bannerItemInfoTransitionUrl,
  .bannerItemInfoGroupName,
  .bannerItemInfoTargetUserType {
    @include typography('Jp/14_W3');
    color: text('Low');
    align-items: center;
    overflow: hidden;

    > span:first-child {
      flex-shrink: 0;
      min-width: 64px;
    }

    > :last-child {
      min-width: 0;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    a {
      color: text('Link');
      text-decoration: none;
    }
  }
}

.bannerItemActions {
  display: flex;
  align-items: center;
  justify-content: center;
}

.emptyContent {
  height: inherit;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: borderRadius('lg');
  border: 1px solid border('Tertiary');
  gap: spacing('24');
  padding: spacing('32');

  &__image {
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: auto;
      height: auto;
      max-width: 100%;
    }
  }
}

.emptyContentDescription {
  @include typography('Jp/16_W3');
  color: text('Low');
}
